export default __webpack_public_path__ + "assets/fonts/Nunito-Italic-3f12a6cf.woff2";